import uuidv4 from 'uuid/v4'

import profileCache from 'services/cache/profile'

function getProfile() {
  let profile = profileCache.read()

  if (!profile) {
    const id = uuidv4()
    profile = {
      id
    }

    profileCache.write(profile)
  }

  return profile
}

export const prefix = 'profile'
export const initialState = getProfile()

export function idSelector(state) {
  return state[prefix].id
}
